import Select from '../commons/select/Select.js'
import Footer from '../commons/footer/Footer.vue'

export default {
  name: 'Home',
  components: {
    Select,
    Footer
  },
  methods: {
    submit: function () {
      this.$router.push('/registration-complete')
    }
  },
  data: function () {
    const days = []
    const years = []
    const actualYear = (new Date()).getFullYear()

    for (let i = 0; i < 55; i++) {
      if (i < 31) {
        days.push(i + 1)
      }

      years.push(actualYear - i)
    }

    return {
      days: days,
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      years: years
    }
  }
}
